const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  appCode: state => state.app.appCode,
  token: state => state.user.token,
  tokenExpriedMins: state => state.user.tokenExpriedMins,
  refreshToken: state => state.user.refreshToken,
  refreshTokenExpriedMins: state => state.user.refreshTokenExpriedMins,
  language: state => state.app.language,
  userInfo: state => state.user.userInfo,
  //合法的权限路径
  permission_routes: state => state.permission.routes,
  userType: state => state.user.userType,
  loginSource: state => state.user.loginSource
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js